@let ctaFormGroup = ctaForm();

@if (ctaFormGroup) {
  <div class="flex flex-col mb-6">
    <span class="text-2xl">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.title' | translate }}
    </span>
    <span class="text-shikenso-purple-base-60">
      {{ 'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.description' | translate }}
    </span>
  </div>

  @if (customModeCreatorId()) {
    <div class="mb-6">
      {{
        'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.changesHereOnlyApplyTo'
          | translate: { creatorName: customModeCreatorName() }
      }}
    </div>
  }

  <app-execution-list
    [formArray]="ctaFormGroup.controls.executions"
    [platformFeature]="selectedPlatformFeature()!"
    [availableKpis]="availableKpis()"
    [creatorId]="customModeCreatorId()"
    [isCustomMode]="!!customModeCreatorId()"
    [creators]="creators()"
    [isAllExpanded]="true"
    [isViewMode]="false"
    [ctaForm]="ctaFormGroup"
    [gamePlayValues]="gamePlayValues()"
  />
}
